module.exports = __webpack_public_path__ + "static/media/20200108_155507.f8d25a7b.jpg";